export default {"gitHash":"5fae5ddf7fbb70a7156819f35ae3900e408155f0","gitHashShort":"5fae5dd","time":1741110426325,"platform":"linux","arch":"x64"};